import React from 'react'
import BackArrowIcon from '@qirapagos/web/src/assets/svg/BackArrow'
import { useFormik } from 'formik'
import {
  Drawer,
  Title,
  HeaderContainer,
  DrawerContainer,
  BackButton,
  ContentContainer,
  Button,
  ButtonsContainer
} from '../DrawerFilterDate/styles'
import { Drawers } from 'store/drawer/types'
import { DatePickerField } from 'components/shared/DatePickerField'
import wrapper from 'components/organisms/Drawers/wrapper'
import * as Yup from 'yup'
import { downloadDebinExcel } from 'utils/debinExport'
import { useAppSelector } from 'hooks/redux'

export interface FormValues {
  dateFrom: Date | null | undefined
  dateTo: Date | null | undefined
}

interface Props {
  showDrawer: boolean
  onClose: () => void
}

const DrawerDownloadDebin: React.FC<Props> = ({ showDrawer, onClose }) => {
  const { data } = useAppSelector(state => state.drawer)
  const drawerData = data[Drawers.DOWNLOAD_DEBIN]
  const debinData = drawerData?.debinData || []

  const formik = useFormik({
    initialValues: {
      dateFrom: null,
      dateTo: null
    },
    validationSchema: Yup.object().shape({
      dateFrom: Yup.date()
        .typeError('Fecha inválida, por favor ingresá una fecha válida')
        .required('Fecha desde es requerida'),
      dateTo: Yup.date()
        .typeError('Fecha inválida, por favor ingresá una fecha válida')
        .when(
          'dateFrom',
          (dateFrom: Date, schema: Yup.DateSchema<Date | null>) => {
            return dateFrom instanceof Date && !isNaN(dateFrom.getTime())
              ? schema.min(
                dateFrom,
                'La fecha hasta debe ser mayor a la fecha desde'
              )
              : schema
          }
        )
        .required('Fecha hasta es requerida')
        .nullable(true)
    }),
    onSubmit: ({ dateFrom, dateTo }: FormValues) => {
      if (dateFrom && dateTo && debinData) {
        downloadDebinExcel(debinData, dateFrom, dateTo)
        onClose()
      }
    }
  })

  return (
    <Drawer
      open={showDrawer}
      onClose={onClose}
      direction="right"
    >
      <DrawerContainer>
        <HeaderContainer>
          <BackButton onPress={onClose}>
            <BackArrowIcon />
          </BackButton>
          <Title>Resumen de DEBIN</Title>
        </HeaderContainer>
        <ContentContainer>
          <DatePickerField formik={formik} name="dateFrom" label="Desde" />
          <DatePickerField formik={formik} name="dateTo" label="Hasta" />
        </ContentContainer>

        <ButtonsContainer>
          <Button onPress={formik.handleSubmit}>
            Descargar Excel
          </Button>
          <Button onPress={onClose} secondary>
            Volver a DEBIN
          </Button>
        </ButtonsContainer>
      </DrawerContainer>
    </Drawer>
  )
}

export default wrapper(DrawerDownloadDebin, Drawers.DOWNLOAD_DEBIN)
